
import { Container, Box, Typography, Link, List, ListItem, Divider } from '@mui/material'
import { Helmet } from "react-helmet";
import MainLayout from '../../components/MainLayout'
import StaticPagesWrapper from '../../components/StaticPagesWrapper'
import ListItemHeader from '../../components/StaticPagesWrapper/ListItemHeader'

function Section({ title, children }) {
    const id = slugify(title);
    return (
        <Box component="section" id={id} sx={{ scrollMarginTop: 96, mb: 3 }}>
            <Typography variant="h6" component="h3" sx={{ fontWeight: 700 }} gutterBottom>
                {title}
            </Typography>
            {children}
        </Box>
    );
}

function slugify(str) {
    return String(str)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // quitar acentos
        .replace(/[^a-z0-9\s.-]/g, "")
        .trim()
        .replace(/\s+/g, "-");
}

const CancelationPolicies = () => (
    <MainLayout>
        <Helmet>
            <title>Política general de cancelación y reembolso de reservaciones - ToursPrivados</title>
            <meta
                name="description"
                content="Política general de cancelación y reembolso de reservaciones."
                data-react-helmet="true"
            />
        </Helmet>
        <StaticPagesWrapper title='Trekzy'>
            <Box mb={8}>
                <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600 }}>
                    POLÍTICA GENERAL DE CANCELACIÓN Y REEMBOLSO DE RESERVACIONES
                </Typography>

                <Typography variant="body1" paragraph>
                    {`Si usted es (i) una persona física o persona moral; o (ii) una agencia de viajes o tours (`}
                    &quot;Agencia&quot;
                    {`) (`}
                    &quot;Usted&quot;
                    {`) y ha realizado (por su propio derecho o en favor de terceras personas) una o más reservas
  de cualquier servicio ofrecido a través del sitio web:`}{" "}
                    <Link href="https://trekzy.com" target="_blank" rel="noopener noreferrer">
                        https://trekzy.com
                    </Link>{" "}
                    o{" "}
                    <Link href="https://toursprivados.com" target="_blank" rel="noopener noreferrer">
                        https://toursprivados.com
                    </Link>{" "}
                    {`(`}
                    &quot;Sitio&quot;
                    {`) operado y/o propiedad de Tour Review, S.L. (`}
                    &quot;TREKZY&quot;
                    {`) según el destino del servicio contratado a través del Sitio) Usted acepta expresamente
  sujetarse a esta Política General de Cancelación y Reembolso de Reservaciones (la `}
                    &quot;Política&quot;
                    {`) una vez que la reserva de cualquier servicio contratado a través del Sitio ha sido confirmada
  por TREKZY (una `}
                    &quot;Reserva Confirmada&quot;
                    {`) por lo que le pedimos leer de manera detenida esta Política previamente a realizar cualquier
  transacción a través del Sitio.`}
                </Typography>


                <Divider sx={{ my: 3 }} />

                <Section title="CANCELACIONES Y MODIFICACIONES.">
                    <Typography variant="body1" paragraph>
                        Usted podrá solicitar a TREKZY, modificaciones, cancelaciones o especificaciones adicionales de su
                        Reserva Confirmada reconociendo que toda resolución a su solicitud de cancelación, modificación o
                        especificaciones adicionales, dependerá estrictamente de la disponibilidad del servicio que Usted haya
                        contratado a través del Sitio por lo que TREKZY establece como regla general un plazo de 48
                        (cuarenta y ocho) horas de anticipación como mínimo para que Usted tenga derecho a que se le reembolse
                        hasta el 100% (cien por ciento), salvo excepciones aplicando posibles restricciones las cuales
                        estarán debidamente descritas en el tour y/o será informado por el proveedor en su momento de
                        confirmación según la jurisdicción del servicio contratado.
                    </Typography>

                    <List sx={{ listStyle: 'disc', pl: 4 }}>
                        <ListItem sx={{ display: 'list-item' }}>
                            Ninguna solicitud de cancelación hecha con menos de 48 (cuarenta y ocho) horas previas a la fecha
                            de la Reserva Confirmada será reembolsable.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            Si el servicio (tour, traslado u otro) se ha reservado con un código promocional o con descuento
                            especial aplicado, no procederá el reembolso al 100%, aun habiéndose cancelado el mismo en los
                            tiempos estipulados. En estos casos, el porcentaje máximo de reembolso será de 80%.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            Los descuentos especiales y/o códigos de promoción serán aplicables únicamente durante las fechas
                            establecidas para el descuento en su Reserva Confirmada. Dichos descuentos no serán retroactivos en
                            reservaciones realizadas en periodos anteriores a la promoción y/o en las que Usted omita ingresar el
                            código de promoción en el campo correspondiente al momento de la reserva.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            En cancelaciones de Reservas Confirmadas motivadas con el fin de recibir un descuento publicado
                            posterior a la compra original, se aplicará una penalización del 20% (veinte por ciento).
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            Los servicios especificados en una Reserva Confirmada constituyen la totalidad del mismo por lo que
                            no habrá devoluciones parciales por servicios o consumos no realizados durante el mismo.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            Para Reservas Confirmadas hechas a través de depósito parcial, en caso de cancelación, el depósito no
                            es reembolsable.
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            Modificaciones de nombres no tienen costo (excepto en la compra de entradas nominales a atracciones
                            que lo requieren).
                        </ListItem>
                        <ListItem sx={{ display: 'list-item' }}>
                            Modificaciones de participantes a la alza tienen costo adicional por persona y sujetos a
                            disponibilidad el día de la Reserva Confirmada.
                        </ListItem>
                    </List>
                </Section>

                <Section title="NO PRESENTACIÓN (NO SHOW).">
                    <Typography variant="body1" paragraph>
                        Si Usted, su(s) acompañante(s) o alguno de ellos/sus clientes simplemente no se presenta(n) al tour
                        o servicio contratado (no show) = No aplica ninguna clase de reembolso por ningún motivo y bajo
                        ninguna circunstancia.
                    </Typography>
                </Section>

                <Section title="CASO FORTUITO/FUERZA.">
                    <Typography variant="body1" paragraph>
                        Esta Política no aplica en casos fortuitos o fuerza mayor como pueden ser huracán, puerto cerrado,
                        tráfico excesivo, inundaciones, caminos enlodados o bloqueados, tormentas tropicales, epidemias,
                        pandemias o cualquier otro fenómeno natural o causado por el hombre y ajenos a TREKZY; para estos casos
                        solamente se aplicará la política de cambio de fecha de su Reserva Confirmada y caso por caso y a
                        entera discreción de TREKZY podrá aplicar el reembolso total o parcial de la Reserva Confirmada.
                    </Typography>
                </Section>

                <Section title="FORMA DE PAGO DEL REEMBOLSO.">
                    <Typography variant="body1" paragraph>
                        Si la Reserva Confirmada ha sido efectivamente cobrada por TREKZY le pediremos que nos indique la
                        cuenta bancaría ligada a la tarjeta asociada a su Reserva Confirmada para realizarle el reembolso de
                        la misma.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Si la Reserva Confirmada no ha sido efectivamente cobrada por TREKZY realizaremos las gestiones
                        necesarias para cancelar el cargo de la Reserva Confirmada. Por favor tome en cuenta que el tiempo en
                        que Usted verá reflejado el reembolso de los fondos o la cancelación del cargo no depende de TREKZY,
                        le sugerimos contactar al banco emisor de su tarjeta para mayor información al respecto.
                    </Typography>
                </Section>

                <Section title="TÉRMINOS Y CONDICIONES DEL SITIO / PRIVACIDAD DE DATOS.">
                    <Typography variant="body1" paragraph>
                        Para información relacionada con los términos y condiciones del Sitio y cómo manejamos sus datos por
                        favor refiérase a los términos y condiciones y a la política de privacidad contenidos en el Sitio.
                    </Typography>
                </Section>

                <Section title="MODIFICACIONES Y ACTUALIZACIONES DE LA PRESENTE POLÍTICA.">
                    <Typography variant="body1" paragraph>
                        TREKZY podrá modificar, ampliar, corregir o actualizar la presente Política, en cualquier momento y a
                        su entera discreción. En todos los casos, publicaremos en el Sitio la fecha de última actualización de
                        esta Política.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        También podremos comunicar estos cambios a través del Sitio o mediante el envío de un correo
                        electrónico a Usted en caso de contar con su dirección pero sin estar obligado a ello.
                    </Typography>
                </Section>

                <Section title="CONTACTO.">
                    <Typography variant="body1" paragraph>
                        Para más información o asistencia, por favor contáctenos en el apartado de Contacto del Sitio.
                    </Typography>
                </Section>

                <Divider sx={{ my: 4 }} />
                <Typography variant="body2" color="text.secondary" paragraph>
                    Última actualización: 10 de agosto de 2024.
                </Typography>
            </Box>
        </StaticPagesWrapper>
    </MainLayout>
)

export default CancelationPolicies
